import { render, staticRenderFns } from "./ProductPolicy.vue?vue&type=template&id=6fc9489a&"
import script from "./ProductPolicy.vue?vue&type=script&lang=js&"
export * from "./ProductPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports